import { SidebarMenuList } from "./sidebar-menu-list.js"

/**
 * Área de navegação principal da sidebar.
 */
export function SidebarContent({
  items,
  collapsed,
  isMobile,
  isPathActive,
  isSectionOpen,
  onSectionOpenChange,
  onNavigate,
  onActiveMenuChange,
}) {
  return (
    <nav className="sidebar-nav flex-1 overflow-y-auto px-3 py-2">
      <SidebarMenuList
        items={items}
        collapsed={collapsed}
        isMobile={isMobile}
        isPathActive={isPathActive}
        isSectionOpen={isSectionOpen}
        onSectionOpenChange={onSectionOpenChange}
        onNavigate={onNavigate}
        onActiveMenuChange={onActiveMenuChange}
      />
    </nav>
  )
}
